"use strict";
Object.keys(Alkami.FlashBanner).forEach((key) => {
    const oldKey = key.replace('show', 'showFlash').replace('hide', 'hideFlash');
    window[oldKey] = function () {
        console.warn(`${oldKey} is deprecated. Please use Alkami.FlashBanner.${key} instead.`);
        return Alkami.FlashBanner[key].apply(null, arguments);
    };
});


